var Fily;
(function (Fily) {
    var Api;
    (function (Api) {
        var Keywords;
        (function (Keywords) {
            function getIdeas(id, offset, limit) {
                if (offset === void 0) { offset = 0; }
                if (limit === void 0) { limit = 10; }
                return Api.send("keywords.".concat(id), {
                    offset: offset,
                    limit: limit
                }, 'GET');
            }
            Keywords.getIdeas = getIdeas;
            function getGalleries(id, offset, limit) {
                if (offset === void 0) { offset = 0; }
                if (limit === void 0) { limit = 10; }
                return Api.send("keywords.".concat(id, ".galleries"), {
                    offset: offset,
                    limit: limit
                }, 'GET');
            }
            Keywords.getGalleries = getGalleries;
            function getPhotos(id, offset, limit) {
                if (offset === void 0) { offset = 0; }
                if (limit === void 0) { limit = 10; }
                return Api.send("keywords.".concat(id, ".photos"), {
                    offset: offset,
                    limit: limit
                }, 'GET');
            }
            Keywords.getPhotos = getPhotos;
            function find() {
                return Api.send("keywords.list", {}, 'GET');
            }
            Keywords.find = find;
            function complete(query) {
                return Api.send("keywords.completion", { q: query }, 'GET');
            }
            Keywords.complete = complete;
        })(Keywords = Api.Keywords || (Api.Keywords = {}));
    })(Api = Fily.Api || (Fily.Api = {}));
})(Fily || (Fily = {}));
